import { useRouterState } from "@tanstack/react-router";
import { useTolgee } from "@tolgee/react";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { readLocale } from "../../lib/locale";
import { initializeLocaleAtom } from "../../stores/locale-store";

export function LocaleSync() {
	const tolgee = useTolgee();
	const initializeLocale = useSetAtom(initializeLocaleAtom);
	const pathname = useRouterState({ select: (s) => s.location.pathname });

	// Re-resolve on every navigation: readLocale() is URL-prefix-aware (/ko/... →
	// ko), so moving between locale-prefixed routes re-syncs the atom + Tolgee.
	useEffect(() => {
		const locale = readLocale();
		initializeLocale();
		tolgee.changeLanguage(locale);
	}, [pathname, initializeLocale, tolgee]);

	return null;
}
